module.exports = __webpack_public_path__ + "img/discord.94a629e.svg";